export interface IAvatarSettings {
    initialChatEngine: string;
    initialTtsEngine: string;
    initialVoiceId: string;
    initialCamera: { id: string };
    initialCharacter: { id: string; title: string; icon: string };
    initialScene: { id: string; title: string };
    initialCharacterPrompt: string;
    logo: string;
    language: string;
    greeting: string;
    avatarId: string;
    avatarDeployUrl: string;
    isNeural: boolean;
};

export const SUBSCRIPTION_CODES = {
  paid: "x91a",
  free: "u0f3",
};
